import React from "react";
import { CircleAlert } from "lucide-react";

import { Banner } from "@/main/react/component/Banner";

export function ErrorBanner(props: {
    icon?: React.ElementType;
    title?: React.ReactNode;
    description: React.ReactNode;
    className?: string;
}) {
    const { icon, ...rest } = props;
    return <Banner variant="error" icon={icon ?? CircleAlert} {...rest} />;
}
